<template>
  <q-menu>
    <q-list>
      <nav-list-item
          v-if="$can('manage-objects')"
          label="Inrichtingselementen"
          route="object.index"
      />
      <nav-list-item
          v-if="$can('manage-categories')"
          label="Categoriebeheer"
          route="category.index"
      />
      <nav-list-item
          v-if="$can('manage-themes')"
          label="Themabeheer"
          route="theme.index"
      />
      <nav-list-item
          v-if="$can('manage-phases')"
          label="Fasebeheer"
          route="phase.index"
      />
      <nav-list-item
          v-if="$can('manage-maps')"
          label="Kaartbeheer"
          route="mapgroup.index"
      />
      <nav-list-item
          v-if="$can('manage-users') || $can('manage-roles')"
          label="Gebruikersbeheer"
          route="user.index"
      />
      <nav-list-item
          v-if="$can('manage-users') || $can('manage-roles')"
          label="Rollenbeheer"
          route="user.role.index"
      />
    </q-list>
  </q-menu>
</template>

<script>
export default {
  name: "NavigationMenu"
}
</script>
